import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const ProgramContext = createContext(null);
const STORAGE_KEY = "podiumscript.active_program_id";

export const ProgramProvider = ({ children }) => {
  const { user } = useAuth();
  const [programs, setPrograms] = useState([]);
  const [activeProgramId, _setActiveProgramId] = useState(
    () => localStorage.getItem(STORAGE_KEY) || ""
  );
  const [loaded, setLoaded] = useState(false);

  const setActiveProgramId = useCallback((id) => {
    _setActiveProgramId(id || "");
    if (id) localStorage.setItem(STORAGE_KEY, id);
    else localStorage.removeItem(STORAGE_KEY);
  }, []);

  const refresh = useCallback(async () => {
    if (!user) {
      setPrograms([]);
      setLoaded(true);
      return;
    }
    try {
      const r = await api.get("/me/programs");
      setPrograms(r.data);
      // Ensure active is valid
      if (r.data.length > 0) {
        const stored = localStorage.getItem(STORAGE_KEY);
        const valid = r.data.find((p) => p.id === stored);
        if (!valid) setActiveProgramId(r.data[0].id);
      } else {
        setActiveProgramId("");
      }
    } catch {
      setPrograms([]);
    } finally {
      setLoaded(true);
    }
  }, [user, setActiveProgramId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const active = programs.find((p) => p.id === activeProgramId) || null;

  return (
    <ProgramContext.Provider
      value={{ programs, activeProgramId, setActiveProgramId, active, loaded, refresh }}
    >
      {children}
    </ProgramContext.Provider>
  );
};

export const usePrograms = () => useContext(ProgramContext);
